// components/Header.js
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const HeaderWrapper = styled.header`
  background-color: ${props => props.theme.colors.primary};
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const HeaderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  width: 32px;  /* Adjust the logo size */
  height: auto;
  margin-right: 8px;  /* Space between the image and text */
`;

const LogoText = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  text-decoration: none;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Header = () => {
  return (
    <HeaderWrapper>
      <HeaderContainer>
        <Link to="/">
          <LogoWrapper>
            <LogoImage src="logo512.png" alt="National Parents Association" />
            <LogoText>National Parents Association</LogoText>
          </LogoWrapper>
        </Link>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;
